<template>
    <div class="col-sm-4 col-md-7 div-center">
        <div class="list-group">
            <button type="button" class="btn btn-primary" data-toggle="modal" data-target="#idAdd" @click="actGetUserList">{{$t('favo.add')}}</button>
            <span class="list-group-item"></span>
            <span class="list-group-item d-flex justify-content-between align-items-center" v-for="(item, index) in favorites" :key="index">
                {{item}}
                <button type="button" class="btn btn-danger" @click="actDeleteFavorite(index)">{{$t('favo.delete')}}</button>
            </span>
        </div>

        <div id="idAdd" ref="idAdd" class="modal fade" tabindex="-1">
            <div class="vertical-alignment-helper">
                <div class="modal-dialog vertical-align-center">

                    <div class="modal-content">
                        <div class="modal-header">
                            {{$t('favo.searchForName')}}
                        </div>

                        <div class="modal-body input-group">
                            <input type="text" class="form-control" v-model="newFavo">
                        </div>
                            <div class="list-group">
                                <li class="list-group-item" v-for="item in filteredList" :key="item.ename" 
                                    @click='selectName(item.ename)'>
                                    {{item.ename}} - {{item.cname}}
                                </li>
                            </div>
    
                        <div class="modal-footer">
                            <button type="button" class="btn btn-primary"  data-dismiss="modal" @click='save'>Add</button>
                            <button type="button" class="btn btn-secondary" data-dismiss="modal" @click='cancel'>Cancel</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
    data() {
        return {
            filteredList: [],
            newFavo: ''
            //favorites: this.$store.state.favorites
        }
    },
    watch: {
        newFavo: function(value) {
            if (value === '') {
                return
            }

            this.filterUserList()
        }
    },

    computed: {
        ...mapGetters({
            userList: 'getUserList',
            favorites: 'getFavorites'
        })
    },

    methods: {
        filterUserList() {
            var list = this.userList
            var favo = this.newFavo
            this.filteredList = list.filter(function(item) {
                //console.log('item: ', item)
                return (item.ename.toLowerCase().indexOf(favo.toLowerCase()) != -1)
            })
        },

        cancel() {
            this.newFavo = ''
            this.filteredList = []
        },

        save(e) {
            if (this.newFavo === '' || this.favorites.includes(this.newFavo)) {
                this.newFavo = ''
                this.filteredList = []
                return
            }

            this.actSaveFavorite(this.newFavo)
            console.log('save: ', this.newFavo)
            this.newFavo = ''
            this.filteredList = []
            //this.$refs.idAdd.classList.toggle('show')
        },

        selectName(ename) {
            this.newFavo = ename
        },

        ...mapActions([
            'actGetUserList',
            'actSaveFavorite',
            'actDeleteFavorite'
        ]),
    }
}
</script>

<style scoped>
@import '../assets/css/custom.css'
</style>


// WEBPACK FOOTER //
// src/pages/Favorite.vue